var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightBottomIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.894 8.34302L9.43164 13.1351V15.9331L18.0001 10.4213L16.894 8.34302Z",
    fill: "#A26128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4213L8.57158 15.9332V13.1352L1.11234 8.33374L0 10.4213Z",
    fill: "#A26128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00145 2.99951L1.75098 7.66075L9.00145 12.3251L16.2582 7.66387L9.00145 2.99951ZM9.00145 5.87228L5.39335 8.19356L4.48977 7.61402L9.00457 4.71009L13.5194 7.61402L12.6158 8.19356L9.00768 5.87228H9.00145Z",
    fill: "#A26128"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 12.9337,
    fill: "white",
    transform: "translate(0 2.99951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBottomIconActive);
export default __webpack_public_path__ + "static/media/right_bottom_icon_active.555b2dd407da2bf277af19dd72bd29a8.svg";
export { ForwardRef as ReactComponent };